import React from "react";
import { FaSyncAlt } from "react-icons/fa";
import { MdOutlineWarning } from "react-icons/md";

/**
 * Displays an error message with option to reload the page
 * @returns {JSX.Element} Error recovery UI with reload button
 */
const ReloadPage = () => {
  /** Reloads the current page */
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="bg-white min-h-screen flex items-center justify-center">
      <div className="text-center">
        <MdOutlineWarning className="text-[#D4640E] w-[70px] h-[60px] mx-auto mb-8" />

        <p className="text-[#35424D] font-semibold text-[25px] h-[31px] mb-4">
          {" "}
          Failed to load the screen{" "}
        </p>
        <p className="text-[#5D6871] text-[16px] font-medium h-[40px] mb-8">
          This may be due to a temporary issue on our end or
          <br />a connection problem.
        </p>

        <button
          type="button"
          onClick={reloadPage}
          className="bg-[#1C40CA] w-[140px] h-[32px] text-white text-xs font-normal justify-center rounded flex items-center mx-auto"
        >
          <FaSyncAlt className="fa-xs w-[16px] h-[16px] mr-1" />
          <span className="text-[13px] h-[16px] w-[69px] font-semibold">
            Reload Page
          </span>
        </button>
      </div>
    </div>
  );
};

export default ReloadPage;
